import React, { useContext } from "react"
import PropTypes from 'prop-types';
import { UserContext } from "../pages/UserContext"

export default function AwaitUserCheck({children}) {
  const { initialUserStorageCheck, initialUserCallbackCheck} = useContext(UserContext);

  if(!initialUserStorageCheck || !initialUserCallbackCheck ){
    return <section />;
  }

  return children
}

AwaitUserCheck.propTypes = {
  children: PropTypes.object.isRequired,
}
